import { httpCreate } from "./http";
import conf from "@/config";

const http = httpCreate(conf.apipath + "/companyRecruit");

export const companyRecruit = {
  pageList(params) {
    return http.get("/pageList", { params });
  },
  createCompany(body) {
    return http.post("/save", body);
  },
  updateCompany(body) {
    return http.put("/update", body);
  },
  deleteCompany(id) {
    return http.delete(`/${id}`);
  }
};
